import { SCHEMA_VERSION, type SaveFile } from './schema';

export interface EmptySaveOptions {
  /** Value of `prefers-reduced-motion`, read by the caller (this layer never touches the DOM). */
  prefersReducedMotion: boolean;
}

/** Document of a first launch: no slots, GDD §6.4 default settings. */
export function createEmptySave({ prefersReducedMotion }: EmptySaveOptions): SaveFile {
  return {
    schemaVersion: SCHEMA_VERSION,
    lastSlotId: null,
    settings: {
      musicVolume: 0.7,
      sfxVolume: 1,
      reducedMotion: prefersReducedMotion,
      assistMode: false,
      showFps: false,
    },
    slots: { 'EXP-01': null, 'EXP-02': null, 'EXP-03': null },
  };
}
